import { NewQuote } from 'quoting/new-quote/new-quote';
import { Redirect } from 'react-router-dom';
import { PERMISSIONS } from 'shared/constants';
import { useTitle } from 'shared/hooks';
import { useUserPermissions } from 'shared/hooks/use-user-permissions';
import { ROUTES } from './routes';

export function NewQuoteResolver() {
  const userPermissions = useUserPermissions();

  useTitle('New Quote - American Bath');

  if (!userPermissions.includes(PERMISSIONS['quoting.view'])) {
    return <Redirect to={ROUTES.unauthorized} />;
  }
  return <NewQuote />;
}
